





















































import { Component, Vue } from 'vue-property-decorator'
import { membershipState } from '../../../store/modules/MembershipState'
import { ssoLogin } from '../../../modules/util/SapUtil'

@Component
export default class NonLoginAlertModal extends Vue {
  // -------------------------------------------------------------------------------------------------------------------
  // methods
  private close() {
    membershipState.addWaitingForAddBookmark(0)
    membershipState.changeNonLoginAlertModalVisible(false)
    this.$emit('close')
  }

  // SignIn画面表示
  private openSignInModal() {
    // SignIn
    const redirectUrl = this.prepareBookmark()
    ssoLogin(redirectUrl, 'gigya-login-screen')
  }

  // 登録画面表示
  private openRegisterModal() {
    const redirectUrl = this.prepareBookmark()
    ssoLogin(redirectUrl, 'gigya-register-screen')
  }

  /**
   *  ブックマーク登録準備
   *  未SignIn状態でSignIn,Registerを押下したとき
   *  ログイン後にブックマークを登録するための準備を行う
   */
  private prepareBookmark() {
    // ワンタイムコード作成
    const oneTimeCode = this.createOneTimeCode()

    // URLの決定
    let bookmarkUrl = membershipState.linkUrlPendingRegistration
    let bookmarkTitle = membershipState.linkUrlTitlePendingRegistration
    if (!bookmarkUrl) {
      bookmarkUrl = window.location.pathname
      bookmarkTitle = document.getElementsByTagName('h1')[0].innerText
    }

    // ローカルストレージにURLとワンタイムコードを保存
    localStorage.setItem(
      'bookmarkStrage',
      oneTimeCode + '<>' + bookmarkUrl + '<>' + bookmarkTitle
    )
    let redirectUrl = ''
    if (window.location.href.indexOf('?') < 0) {
      redirectUrl = window.location.href + '?book=' + oneTimeCode
    } else {
      redirectUrl = window.location.href + '&book=' + oneTimeCode
    }
    return redirectUrl
  }

  // ワンタイムコードの作成
  private createOneTimeCode() {
    const d = new Date()
    const nowTime =
      d.getUTCDay().toString() +
      d.getUTCDate().toString() +
      d.getUTCMonth().toString() +
      d.getUTCFullYear().toString() +
      d.getUTCHours().toString() +
      d.getUTCMinutes().toString() +
      d.getUTCSeconds().toString() +
      d.getUTCMilliseconds().toString()
    return nowTime
  }
}
